export default __webpack_public_path__ + "static/media/desktop_logo.69d5e957.svg";